import { InitService } from './init.service'
import type { AxiosResponse } from 'axios'
import type ObraGeolocalizada from './model/obra-geolocalizada'
import type RetornoGenerico from './model/retorno-generico'

export class ObraFavoritaService extends InitService {
  public obterTodas(): Promise<AxiosResponse<Array<ObraGeolocalizada>>> {
    return this.get(`Favoritos/ObterObrasFavoritas`)
  }

  public adicionar(codigoLote: number): Promise<RetornoGenerico> {
    return this.post(`Favoritos/AdicionarFavorito/${codigoLote}`)
  }

  public remover(codigoLote: number): Promise<RetornoGenerico> {
    return this.post(`Favoritos/RemoverFavorito/${codigoLote}`)
  }

  public async carregar(): Promise<number[]> {
    const response = await this.get(`Favoritos/ObterObrasFavoritasUsuario`)
    const resultArray: number[] = response.data
    return resultArray
  }
}

const obraFavoritaService = new ObraFavoritaService()
export default obraFavoritaService
